import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { gql } from "types";

export const SIGNAL_WORKFLOW_RUN = gql(/* GraphQL */ `
  mutation SignalWorkflowRun($runId: String!) {
    signalWorkflowRun(runId: $runId) {
      id
      status
    }
  }
`);

export const useSignalWorkflowRun = () => {
  const [signalWorkflowRun, { loading }] = useMutation(SIGNAL_WORKFLOW_RUN);

  const signalRun = useCallback(
    (runId: string) => signalWorkflowRun({ variables: { runId } }),
    [signalWorkflowRun],
  );

  return { signalRun, loading };
};
